/* global-helpers.js
   Restaura las funciones base que el tema Bitcoworld cargaba desde
   https://bitcoworld.netlify.app/js/v2/main.js (archivo externo que ahora está vacío).
   Sin estas funciones, la galería de imágenes del producto (lightbox y miniaturas) falla.
   Cargar ANTES de secondary.js. */

(function () {
  'use strict';

  if (!window.getFocusableElements) {
    window.getFocusableElements = function (container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
  }

  var trapFocusHandlers = {};

  if (!window.trapFocus) {
    window.trapFocus = function (container, elementToFocus) {
      if (elementToFocus === undefined) elementToFocus = container;
      var elements = window.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];

      window.removeTrapFocus();

      trapFocusHandlers.focusin = function (event) {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', trapFocusHandlers.keydown);
      };

      trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
      };

      trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return;
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };

      document.addEventListener('focusout', trapFocusHandlers.focusout);
      document.addEventListener('focusin', trapFocusHandlers.focusin);

      if (elementToFocus) elementToFocus.focus();

      if (
        elementToFocus &&
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].indexOf(elementToFocus.type) !== -1 &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
    };
  }

  if (!window.removeTrapFocus) {
    window.removeTrapFocus = function (elementToFocus) {
      document.removeEventListener('focusin', trapFocusHandlers.focusin);
      document.removeEventListener('focusout', trapFocusHandlers.focusout);
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
      if (elementToFocus) elementToFocus.focus();
    };
  }

  if (!window.pauseAllMedia) {
    window.pauseAllMedia = function () {
      document.querySelectorAll('.js-youtube').forEach(function (video) {
        try {
          video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } catch (e) {}
      });
      document.querySelectorAll('.js-vimeo').forEach(function (video) {
        try {
          video.contentWindow.postMessage('{"method":"pause"}', '*');
        } catch (e) {}
      });
      document.querySelectorAll('video').forEach(function (video) {
        try { video.pause(); } catch (e) {}
      });
      document.querySelectorAll('product-model').forEach(function (model) {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    };
  }

  if (!window.onKeyUpEscape) {
    window.onKeyUpEscape = function (event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      var openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;
      var summaryElement = openDetailsElement.querySelector('summary');
      openDetailsElement.removeAttribute('open');
      summaryElement.setAttribute('aria-expanded', false);
      summaryElement.focus();
    };
  }

  if (!window.debounce) {
    window.debounce = function (fn, wait) {
      var t;
      return function () {
        var args = arguments;
        var ctx = this;
        clearTimeout(t);
        t = setTimeout(function () {
          fn.apply(ctx, args);
        }, wait);
      };
    };
  }

  if (!window.throttle) {
    window.throttle = function (fn, delay) {
      var lastCall = 0;
      return function () {
        var now = Date.now();
        if (now - lastCall < delay) return;
        lastCall = now;
        return fn.apply(this, arguments);
      };
    };
  }
})();
